/** Shop portal auth after invite signup. First ID token can omit custom claims. */

export const SHOP_JOBS_PATH = '/app/jobs';
export const SHOP_NOT_SHOP_USER = "This is not a shop user's account.";

export function hasShopUserClaims(claims) {
  return (
    claims?.shopUser === true &&
    typeof claims.shopId === 'string' &&
    claims.shopId.length > 0 &&
    typeof claims.regionId === 'string' &&
    claims.regionId.length > 0
  );
}

/**
 * Custom claims set by registerShopUser can be absent from the first cached token.
 * Force-refresh once before treating the session as a non-shop account (admin #39 pattern).
 */
export async function resolveShopUserToken(user) {
  if (!user?.getIdTokenResult) {
    return { token: null, refreshed: false };
  }
  let token = await user.getIdTokenResult();
  if (hasShopUserClaims(token?.claims)) {
    return { token, refreshed: false };
  }
  token = await user.getIdTokenResult(true);
  return { token, refreshed: true };
}
